import { useSyncExternalStore } from 'react';
import type { AddedAssetTheme } from 'fym-shared/src/music24/addedAssets';

/** The tabs of the "Add …" dialog (design music-video a2–a4). */
export type AddAssetTab = 'youtube' | 'upload' | 'make';

/**
 * What the "Add …" dialog shows: one song and one asset type. The Kit slots, the Catalog field and
 * the Overview open it; `AddAssetHost` (in `SMLContainer`) draws it. A small store outside React,
 * like the publish dialog, so a slot deep in a grid needs no prop chain.
 */
export interface AddAssetRequest {
  accountId: number;
  catalogItemUuid: string;
  songTitle: string;
  /** `YYYY-MM-DD` or an ISO time; null with no date. The publish switch reads it. */
  releaseDate: string | null;
  /** The length of the master, for the length line; null with no master. */
  songDurationSec: number | null;
  themeId: AddedAssetTheme;
  /** The first tab. Absent: YouTube when the asset type takes a link, else the upload. */
  tab?: AddAssetTab;
}

let current: AddAssetRequest | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function openAddAssetDialog(request: AddAssetRequest): void {
  current = request;
  emit();
}

export function closeAddAssetDialog(): void {
  current = null;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useAddAssetRequest(): AddAssetRequest | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => null
  );
}
